import { instance } from './instance';
import { ApiCreateProps, ApiDeleteProjectUserProps, ApiEditProps, ApiProjectFormData, ApiSuccessGetProject } from '@/dashboard/api/types/apiTypes';

export const ProjectApi = {
  create: async ({ name, allowPublic, team, workspaceShortLink, visibility }: ApiCreateProps): Promise<ApiSuccessGetProject> => {
    const formData = projectFormData({ name, allowPublic, team, shortLink: workspaceShortLink, visibility });
    const response = await instance.post(`/app/projects/create`, formData);
    return response.data;
  },
  edit: async ({ name, allowPublic, projectShortLink, visibility, team }: ApiEditProps): Promise<ApiSuccessGetProject> => {
    const formData = projectFormData({ name, allowPublic, team, shortLink: projectShortLink, visibility });
    const response = await instance.post(`/app/projects/edit`, formData);
    return response.data;
  },
  getByShortLink: async (shortLink: string): Promise<ApiSuccessGetProject> => {
    const params = {
      short_link: shortLink,
    };
    const response = await instance.get('/app/projects/project', { params: params });
    return response.data;
  },
  deleteUser: async ({ projectShortLink, userId }: ApiDeleteProjectUserProps): Promise<ApiSuccessGetProject> => {
    const formData = new FormData();
    formData.append('short_link', projectShortLink);
    formData.append('user_id', `${userId}`);
    const response = await instance.post(`/app/projects/delete_user`, formData);
    return response.data;
  },
  getUserDraftIds: async (shortLink: string): Promise<{ ids: number[] }> => {
    const params = {
      short_link: shortLink,
    };
    const response = await instance.get('/app/projects/get_all_ids', { params: params });
    return response.data;
  },
};

function projectFormData({ allowPublic, shortLink, name, visibility, team }: ApiProjectFormData): FormData {
  const teamJson = JSON.stringify(team.map((user) => user.json()));
  const formData = new FormData();
  formData.append('short_link', shortLink);
  formData.append('name', name);
  formData.append('allow_public', `${allowPublic}`);
  formData.append('team', teamJson);
  formData.append('visibility', visibility);

  return formData;
}
